const addAsterisks = () => {
    document.addEventListener("facetwp-loaded", (e) => {
        const allTitles = Array.from(document.querySelectorAll(".company-survey__result--title"));

        if (allTitles.length > 0) {
            if (!allTitles[0]?.dataset?.topNumber) {
                return;
            }
            let priorNumber = 0;
            let editedPrevious = false;

            allTitles.forEach(title => {
                let thisNumber = parseInt(title.dataset.topNumber);
                let thisCounter = parseInt(title.dataset.counter);
                if (!editedPrevious) {
                    if (thisNumber === priorNumber) {
                        let priorCounter = thisCounter - 1;
                        let priorElement = document.querySelector(`.company-survey__result--title[data-counter='${priorCounter}']`);
                        console.log(priorElement);
                        
                        if (priorElement) {
                            priorElement.insertAdjacentText("beforeend", "*");
                            editedPrevious = true;
                            title.insertAdjacentText("beforeend", "*");
                        }
                    }
                } else {
                    if (thisNumber === priorNumber) {
                        title.insertAdjacentText("beforeend", "*");
                    } else {
                        editedPrevious = false;
                    }
                }

                priorNumber = thisNumber;
            })
        }
    })
}

export { addAsterisks };